module.exports = __webpack_public_path__ + "images/52f7f9c4b218ff0fd7b5ba9f06234b1b.png";